var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeller({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.678,
    height: 18.68,
    viewBox: "0 0 15.678 18.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16421",
    d: "M351.234 11.779h2.905l-2.905-2.888zm0 0",
    transform: "translate(-339.002 -8.89)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16422",
    d: "M62.5 3.657a.543.543 0 0 1-.543-.543V0h-9.07a.543.543 0 0 0-.543.543v9.685a4.785 4.785 0 0 1 2.775-.274.542.542 0 0 1 .486-.785h6.545a.543.543 0 1 1 0 1.087h-6.069a4.777 4.777 0 0 1 2.382 6.505h6.619a.543.543 0 0 0 .543-.543V3.657zm-2.309 1.78a.543.543 0 0 1-.543.543h-4.043a.543.543 0 0 1 0-1.087h4.045a.543.543 0 0 1 .544.545zm1.959 2.681h-6.545a.543.543 0 0 1 0-1.087h6.545a.543.543 0 1 1 0 1.087zm0 0",
    transform: "translate(-50.487)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16423",
    d: "M7.886 309.435a3.693 3.693 0 1 0-3.693 3.693 3.7 3.7 0 0 0 3.693-3.693zM3.9 310.91a.543.543 0 0 1-.754-.065l-1.121-1.292a.543.543 0 0 1 .821-.712l.776.895 1.847-1.5a.543.543 0 0 1 .686.843zm0 0",
    transform: "translate(-.5 -294.794)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeller);
export default __webpack_public_path__ + "static/media/seller.27ae688f8a75817b824a63059e9e9438.svg";
export { ForwardRef as ReactComponent };